import React from 'react';

import S from './VoiceMemos.module.css';

export const VoiceMemosImg = () => (
  <div className={S.root}>
    <div className={S.mic}></div>
    <sub></sub>
    <sup></sup>
  </div>
);
